import type { Order } from '../types';
import { formatPrice } from './utils';

export interface OrderContactDetails {
  name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  notes: string;
  shipping: number;
  priorityDelivery: boolean;
}

export function normalizePhone(value: string): string {
  return value.replace(/\D/g, '').replace(/^57(?=3\d{9}$)/, '');
}

export function isValidColombianMobile(value: string): boolean {
  return /^3\d{9}$/.test(normalizePhone(value));
}

export function buildOrderWhatsAppUrl(details: OrderContactDetails, order: Order, whatsappNumber: string, paymentUrl?: string): string {
  const itemList = (order.items || [])
    .map((item, i) => `${i + 1}. ${item.name} x${item.quantity} - ${formatPrice(item.price * item.quantity)}`)
    .join('\n');

  const message =
    `🛒 *NUEVO PEDIDO TECNICELU S.A.*\n\n` +
    `👤 *Cliente:* ${details.name}\n` +
    `📧 *Email:* ${details.email}\n` +
    `📱 *Teléfono:* ${details.phone}\n` +
    `📍 *Dirección:* ${details.address}, ${details.city}\n\n` +
    `📦 *Productos:*\n${itemList}\n\n` +
    `🚚 *Envío:* ${formatPrice(details.shipping)}\n` +
    (details.priorityDelivery ? `⚡ *Entrega prioritaria:* Sí\n` : '') +
    `💰 *Total:* ${formatPrice(order.total)}\n` +
    (paymentUrl ? `🔗 *Pago:* ${paymentUrl}\n` : '') +
    `\n` +
    `📝 *Notas:* ${details.notes || 'Ninguna'}`;

  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}
